import { useCallback, useRef, useState } from "react";
import { fetchOverviewSearch } from "../services/overviewSearchService";

export default function useOverviewSearch() {
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const lastQueryRef = useRef("");

	const runSearch = useCallback(async (queryOrPayload) => {
		setLoading(true);
		setError(null);
		try {
			const res = await fetchOverviewSearch(queryOrPayload);
			setResults(res.results || []);
			lastQueryRef.current = typeof queryOrPayload === "string" ? queryOrPayload : (queryOrPayload?.query || "");
		} catch (e) {
			setError(e?.response?.data?.message || e.message || "Failed to search");
			setResults([]);
		} finally {
			setLoading(false);
		}
	}, []);

	const clear = useCallback(() => {
		setResults([]);
		setError(null);
	}, []);

	return { results, loading, error, runSearch, clear, lastQuery: lastQueryRef.current };
}


